export default __webpack_public_path__ + "static/media/fleche_blanc.eb6edb5f.svg";